module.exports = __webpack_public_path__ + "static/media/artwork_blank.4e879407.jpg";